<template>
  <div>
    <ActionButton :title="title" color="default" :icon="icon" @click="onButtonClick" />
    <input type="file" style="display:none;" ref="fileField" :accept="accept" @change="onFileSelect" />
  </div>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { Prop, Ref, Emit } from "vue-property-decorator";
import ActionButton from "../atoms/ActionButton.vue";
@Options({
  components: { ActionButton }
})
export default class FileSelectorButton extends Vue {
  @Prop({ type: String }) title = "";
  @Prop({ type: String }) icon = "";
  @Prop({ type: String }) accept = "";
  @Ref("fileField") fileField!: HTMLElement;
  onButtonClick() {
    this.fileField.click();
  }
  @Emit("select-file")
  onFileSelect(event: Event) {
    const target = event.target as HTMLInputElement;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const file = target.files![0];
    target.value = "";
    return file;
  }
}
</script>
